/* ============
 * Supplier Module State
 * ============
 */

export default {
  all: [],
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  currentAdjustment: [],
  stockProducts: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/adjustment/state.js